import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  dateFormatter,
  infoFormatter, infoFormatterIntl, localeFormatter, userFIOFormatter,
} from '../../../../utils/formatters';
import { intlShape } from '../../../../components/base/IntlProviderWrapper';
import FileView from '../../../../components/fields/FileInput/FileView';

export default function PersonView({
  applicant = {}, isRepresentative = false, prefix = '', fieldsValidation, isPreview, files = [],
}) {
  const {
    inn,
    address,
    phone,
    email,
    birth_date,
    gender,
    citizenship,
    registration_type,
    place_of_birth,
    snils,
    identity_type,
    identity_series,
    identity_number,
    identity_issuer,
    identity_issue_date,
    office_address,
    first_name,
    last_name,
    middle_name,
    legal_entity_type,
  } = applicant;
  const {
    formatMessage,
  } = intlShape;

  const applicant_identity_files = files && files.length ? files.find(item => item.collection_name === 'applicant_identity_files') : undefined;

  function PreviewPrivatePersonView() {
    return (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl('legal_entity_type', localeFormatter('user.type', legal_entity_type), fieldsValidation, 'applicant.legal_entity_type')}
          {infoFormatterIntl('inn', inn, fieldsValidation, `${prefix}inn`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('last_name', last_name, fieldsValidation, `${prefix}last_name`)}
          {infoFormatterIntl('first_name', first_name, fieldsValidation, `${prefix}first_name`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('middle_name', middle_name, fieldsValidation, `${prefix}middle_name`)}
          {infoFormatterIntl('phone', phone, fieldsValidation, `${prefix}phone`)}
        </Row>
        <Row className="row-cols-2">

          {infoFormatterIntl('email', email, fieldsValidation, `${prefix}email`)}
          {infoFormatterIntl('registration_address', address, fieldsValidation, `${prefix}address`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('home_address', office_address, fieldsValidation, `${prefix}office_address`)}
          {infoFormatterIntl('citizenship', localeFormatter('citizenship.type', citizenship), fieldsValidation, `${prefix}citizenship`)}
        </Row>
      </>
    );
  }

  function FullPrivatePersonView() {
    return (
      <>
        <Row className="row-cols-2">
          {infoFormatterIntl('legal_entity_type', localeFormatter('user.type', legal_entity_type), fieldsValidation, 'applicant.legal_entity_type')}
          {infoFormatterIntl('inn', inn, fieldsValidation, `${prefix}inn`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('last_name', last_name, fieldsValidation, `${prefix}last_name`)}
          {infoFormatterIntl('first_name', first_name, fieldsValidation, `${prefix}first_name`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('middle_name', middle_name, fieldsValidation, `${prefix}middle_name`)}
          {infoFormatterIntl('phone', phone, fieldsValidation, `${prefix}phone`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('email', email, fieldsValidation, `${prefix}email`)}
          {infoFormatterIntl('registration_address', address, fieldsValidation, `${prefix}address`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('home_address', office_address, fieldsValidation, `${prefix}office_address`)}
          {infoFormatterIntl('identity_type', localeFormatter('identity.type', identity_type), fieldsValidation, `${prefix}identity_type`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('identity_series', identity_series, fieldsValidation, `${prefix}identity_series`)}
          {infoFormatterIntl('identity_number', identity_number, fieldsValidation, `${prefix}identity_number`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('identity_issue_date', dateFormatter(identity_issue_date), fieldsValidation, `${prefix}identity_issue_date`)}
          {infoFormatterIntl('identity_issuer', identity_issuer, fieldsValidation, `${prefix}identity_issuer`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('birth_date', dateFormatter(birth_date), fieldsValidation, `${prefix}birth_date`)}
          {infoFormatterIntl('gender', localeFormatter('gender', gender), fieldsValidation, `${prefix}gender`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('citizenship', localeFormatter('citizenship.type', citizenship), fieldsValidation, `${prefix}citizenship`)}
          {infoFormatterIntl('registration_type', localeFormatter('registration.type', registration_type), fieldsValidation, `${prefix}registration_type`)}
        </Row>
        <Row className="row-cols-2">
          {infoFormatterIntl('place_of_birth', place_of_birth, fieldsValidation, `${prefix}place_of_birth`)}
          {infoFormatterIntl('snils', snils, fieldsValidation, `${prefix}snils`)}
        </Row>
        <Row className="row-cols-1">
          {infoFormatterIntl('applicant_identity_files', applicant_identity_files ? <FileView readOnly withoutMime withoutHr files={[applicant_identity_files]} /> : null, fieldsValidation, '', 6)}
        </Row>
      </>
    );
  }

  return isPreview ? <PreviewPrivatePersonView /> : <FullPrivatePersonView />;
}
